import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Nav,
  OverlayTrigger,
  Row,
  Spinner,
  Tab,
  Tooltip
} from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import AddScheduleModal from './AddScheduleModal';
import CalendarEventModal from './CalendarEventModal';
import DropdownFilter from 'components/common/DropdownFilter';
import { getFullScheduleAllData } from 'nursd-dashboard/api/fullSchedule';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import moment from 'moment';
import { toast } from 'react-toastify';
import { updateJobTable } from 'nursd-dashboard/api/jobTable';
import {
  getAllAgencyOrgList,
  getAllFacilityOrgList
  // getAllNurseOrgList
} from 'nursd-dashboard/api/organizationTable';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import PropTypes from 'prop-types';
// import paths from 'routes/paths';
// import { Link } from 'react-router-dom';
// import { getCustomerTableList } from 'nursd-dashboard/api/customerTable';

import ShareEventModal from './ShareEventModal';
import paths from 'routes/paths';
import { Link } from 'react-router-dom';
import SimpleBarReact from 'simplebar-react';
import { socket } from 'nursd-dashboard/api/socket';
import Roster from './roster';
// import { licenseTypes } from 'nursd-dashboard/data/defaultData';

const Calendar = () => {
  const {
    config: { isRTL }
  } = useAppContext();
  const calendarRef = useRef();
  const animatedComponents = makeAnimated();
  const [title, setTitle] = useState('');
  const [calendarApi, setCalendarApi] = useState({});
  const [currentFilter, setCurrentFilter] = useState('Month View');
  const [isOpenScheduleModal, setIsOpenScheduleModal] = useState(false);
  const [isOpenEventModal, setIsOpenEventModal] = useState(false);
  const [modalEventContent, setModalEventContent] = useState({});
  const [scheduleStartDate, setScheduleStartDate] = useState();
  const [scheduleEndDate, setScheduleEndDate] = useState();
  const [valueCustomer, setValueCustomer] = useState(undefined);
  // const [valueLicense, setValueLicense] = useState([
  //   { value: '1', label: 'LPN' },
  //   { value: '2', label: 'CNA' },
  //   { value: '3', label: 'RN' },
  //   { value: '4', label: 'HHA' }
  // ]);

  const [showShare, setShowShare] = useState(false);

  const eventTimeFormat = {
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: true
  };

  const handleEventClick = info => {
    console.log(info);
    if (info.event.url) {
      window.open(info.event.url);
      info.jsEvent.preventDefault();
    } else {
      setModalEventContent(info);
      setIsOpenEventModal(true);
    }
  };

  const { authToken, location, organization } = useAuth();

  const [loading, setLoading] = useState(true);
  const [initialEvents, setInitialEvents] = useState([]);
  const [facilityId, setFacilityId] = useState(undefined);
  const [managers, setManagers] = useState([]);
  const [agency, setAgency] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [nurseList, setNurseList] = useState([]);
  const [downloadData, setDownloadData] = useState([]);

  const viewName = [
    'Month View',
    'Week View',
    'Day View',
    'List View',
    'Year View'
  ];

  const handleFilter = filter => {
    setCurrentFilter(filter);
    switch (filter) {
      case 'Month View':
        calendarApi?.changeView('dayGridMonth');
        setTitle(calendarApi?.getCurrentData().viewTitle);
        break;
      case 'Week View':
        calendarApi?.changeView('timeGridWeek');
        setTitle(calendarApi?.getCurrentData().viewTitle);
        break;
      case 'Day View':
        calendarApi?.changeView('timeGridDay');
        setTitle(calendarApi?.getCurrentData().viewTitle);
        break;
      case 'List View':
        calendarApi?.changeView('listWeek');
        setTitle(calendarApi?.getCurrentData().viewTitle);
        break;
      default:
        calendarApi?.changeView('listYear');
        setTitle(calendarApi?.getCurrentData().viewTitle);
    }
  };

  const getAllData = async (
    authToken,
    userId,
    licenseTypes,
    unassigned,
    customerListId
  ) => {
    // console.log(licenseTypes, customerListId);
    setLoading(true);
    setDownloadData([]);
    await getFullScheduleAllData(authToken, userId, licenseTypes, unassigned)
      .then(res => {
        // console.log(res);
        if (res) {
          let jobData = res?.jobData;
          let customerData = res?.customerList;
          let nurseData = res?.nurseList;

          let data = [];
          let dataCustomer = [];
          let dataNurse = [];

          // console.log(res?.jobData);

          const filteredJobArray = jobData?.filter(item => {
            return customerListId?.some(
              selectCustomer => item.customerName === selectCustomer
            );
          });

          const jobList = valueCustomer ? filteredJobArray : jobData;

          // console.log(jobList);

          const licenseFilterJob = jobList.filter(item =>
            licenseTypes?.some(type => item.licenseType.includes(type))
          );

          // console.log(licenseFilterJob);

          const finalFilter = licenseFilterJob;

          //Job
          for (let i = 0; i < finalFilter?.length; i++) {
            const item = finalFilter[i];
            let obj = {
              id: item?.id,
              title: item?.shiftTitle,
              backgroundColor:
                item?.jobStatus === 'Unfulfilled'
                  ? '#888'
                  : item?.jobStatus === 'Open' ||
                    item?.jobStatus === 'Pending Assignment'
                  ? '#ffff00'
                  : item?.jobStatus === 'Completed'
                  ? '#00b359'
                  : item?.jobStatus === 'Nurse Assigned' ||
                    item?.jobStatus === 'In-Progress' ||
                    item?.jobStatus === 'Pending Approval'
                  ? '#2775BD'
                  : item?.jobStatus === 'Missed' ||
                    item?.jobStatus === 'Pending Clock Out'
                  ? '#fc0505'
                  : '#888',
              textColor:
                item?.jobStatus === 'Unfulfilled'
                  ? '#fff'
                  : item?.jobStatus === 'Open' ||
                    item?.jobStatus === 'Pending Assignment'
                  ? '#000'
                  : item?.jobStatus === 'Completed'
                  ? '#fff'
                  : item?.jobStatus === 'Nurse Assigned' ||
                    item?.jobStatus === 'In-Progress' ||
                    item?.jobStatus === 'Pending Approval'
                  ? '#fff'
                  : item?.jobStatus === 'Missed' ||
                    item?.jobStatus === 'Pending Clock Out'
                  ? '#fff'
                  : '#fff',
              start: new Date(item?.startTime),
              end: new Date(item?.endTime),
              allDay: true,
              description: item?.fullAddress,
              original: item,
              editable: item?.jobStatus === 'Open',
              status: item?.jobStatus
              // className:
              //   item?.jobStatus === 'Open' ||
              //   item?.jobStatus === 'Pending Assignment'
              //     ? 'bg-warning-subtle'
              //     : item?.jobStatus === 'Pending Approval' ||
              //       item?.jobStatus === 'In-Progress' ||
              //       item?.jobStatus === 'Nurse Assigned'
              //     ? 'bg-primary-subtle'
              //     : item?.jobStatus === 'Completed'
              //     ? 'bg-success-subtle'
              //     : item?.jobStatus === 'Missed' ||
              //       item?.jobStatus === 'Pending Clock Out'
              //     ? 'bg-danger-subtle'
              //     : 'bg-secondary-subtle'
            };
            // console.log('Initial event times:', obj.start, obj.end); // Logging initial event times
            data.push(obj);
          }

          let array = [];

          for (let i = 0; i < finalFilter?.length; i++) {
            const item = finalFilter[i];
            let obj = {
              LicenseType: item.licenseType,
              Title: item.shiftTitle,
              JobType: item.jobType,
              StartDate: moment(item.startDate).format('MM-DD-YYYY'),
              EndDate: moment(item.endDate).format('MM-DD-YYYY'),
              StartTime: moment(item.startTime).format('hh:mm a'),
              EndTime: moment(item.endTime).format('hh:mm a'),
              Break: item.break,
              CustomerName: item.customerName,
              Unit: item.unit,
              Floor: item.floor,
              FullAddress: item.fullAddress,
              Notes: item.notes,
              CustomerVisibility: item.customerVisibility ? 'Yes' : 'No',
              Status: item?.jobStatus,
              Type: item?.jobType
            };
            array.push(obj);
          }

          if (finalFilter?.length === data?.length) {
            setInitialEvents(data);
          }

          if (finalFilter?.length === array?.length) {
            setDownloadData(array);
          }

          //Customer
          const listCustomerData = customerData?.sort((a, b) =>
            a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
          );
          for (let i = 0; i < listCustomerData.length; i++) {
            const item = listCustomerData[i];
            let obj = {
              value: item.id,
              name: item.firstName + ' ' + item.lastName,
              label: item.firstName + ' ' + item.lastName,
              avatar: {
                name: item.firstName + ' ' + item.lastName
              },
              email: item.email,
              address: item.fullAddress,
              latitude: item.latitude,
              longitude: item.longitude,
              phone: item.phoneOne,
              status: item?.active,
              joined: item.createdAt,
              original: item
            };
            dataCustomer?.push(obj);
          }
          if (listCustomerData?.length === dataCustomer?.length) {
            setCustomers(dataCustomer);
          }
          //Nurse
          const listNurseData = nurseData?.sort((a, b) =>
            a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
          );
          for (let i = 0; i < listNurseData?.length; i++) {
            const item = listNurseData[i];
            let obj = {
              id: item.id,
              uniqueId: item.uniqueId,
              name: item.firstName + ' ' + item.lastName,
              label: item.firstName + ' ' + item.lastName,
              value: item.id,
              profileImage: item.profileImage,
              primaryLicenseType: item.primaryLicenseType,
              nurseLoginControl: item?.nurseLoginControl,
              nurseAppAccessControl: item.nurseAppAccessControl,
              original: item
            };
            dataNurse.push(obj);
          }
          if (listNurseData?.length === dataNurse?.length) {
            setNurseList(dataNurse);
          }
          setLoading(false);
        }
      })
      .catch(e => console.log(e));
  };

  const getManager = async () => {
    try {
      const cusList = await getAllFacilityOrgList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          value: item.id,
          uniqueId: item.uniqueId,
          name: item.firstName + ' ' + item.lastName,
          label: item.firstName + ' ' + item.lastName,
          profileImage: item.profileImage,
          emailId: item.emailId,
          facilityLoginControl: item?.facilityLoginControl
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setManagers(array);
        setFacilityId(array[0]?.id);
      }
    } catch (error) {
      setFacilityId(undefined);
    }
  };

  const getAgency = async () => {
    try {
      const dataList = await getAllAgencyOrgList(
        authToken,
        location,
        organization
      );

      const list = dataList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          uniqueId: item.uniqueId,
          name: item.firstName + ' ' + item.lastName,
          profileImage: item.profileImage,
          emailId: item.emailId,
          agencyLoginControl: item?.agencyLoginControl,
          licenseTypes: item?.additionalFields[0]?.licenseTypes,
          original: item
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setAgency(array);
      }
    } catch (error) {
      setAgency([]);
    }
  };

  // const getCustomer = async () => {
  //   try {
  //     const cusList = await getCustomerTableList(
  //       authToken,
  //       location,
  //       organization
  //     );

  //     const list = cusList.sort((a, b) =>
  //       a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
  //     );
  //     let array = [];
  //     for (let i = 0; i < list.length; i++) {
  //       const item = list[i];
  //       let obj = {
  //         value: item.id,
  //         name: item.firstName + ' ' + item.lastName,
  //         label: item.firstName + ' ' + item.lastName,
  //         avatar: {
  //           name: item.firstName + ' ' + item.lastName
  //         },
  //         email: item.email,
  //         address: item.fullAddress,
  //         latitude: item.latitude,
  //         longitude: item.longitude,
  //         phone: item.phoneOne,
  //         status: item?.active,
  //         joined: item.createdAt,
  //         original: item
  //       };
  //       array.push(obj);
  //     }

  //     if (list.length === array.length) {
  //       setCustomers(array);
  //     }
  //   } catch (error) {
  //     setCustomers([]);
  //   }
  // };

  // const getNurse = async () => {
  //   try {
  //     const cusList = await getAllNurseOrgList(
  //       authToken,
  //       location,
  //       organization
  //     );

  //     const list = cusList.sort((a, b) =>
  //       a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
  //     );
  //     let array = [];
  //     for (let i = 0; i < list.length; i++) {
  //       const item = list[i];
  //       let obj = {
  //         id: item.id,
  //         uniqueId: item.uniqueId,
  //         name: item.firstName + ' ' + item.lastName,
  //         profileImage: item.profileImage,
  //         primaryLicenseType: item.primaryLicenseType,
  //         nurseLoginControl: item?.nurseLoginControl,
  //         nurseAppAccessControl: item.nurseAppAccessControl,
  //         original: item
  //       };
  //       array.push(obj);
  //     }

  //     if (list.length === array.length) {
  //       setNurseList(array);
  //     }
  //   } catch (error) {
  //     setNurseList([]);
  //   }
  // };

  useEffect(() => {
    if (authToken && facilityId) {
      getAllData(
        authToken,
        facilityId,
        ['CNA', 'LPN', 'HHA', 'RN'],
        true,
        [valueCustomer]?.map(i => i?.name)
      );
    }
  }, [authToken, facilityId, valueCustomer]);

  useEffect(() => {
    socket?.on('tableJobInsertEvent', data => {
      if (
        data?.table === 'JobPostingTable' &&
        data?.message === 'Fetch Dashboard Job'
      ) {
        if (authToken && facilityId) {
          getAllData(
            authToken,
            facilityId,
            ['CNA', 'LPN', 'HHA', 'RN'],
            true,
            [valueCustomer]?.map(i => i?.name)
          );
        }
      }
    });
  }, [socket]);

  useEffect(() => {
    if (location !== '') {
      getManager();
      getAgency();
      // getCustomer();
      // getNurse();
    }
  }, [authToken, location]);

  useEffect(() => {
    setCalendarApi(calendarRef?.current?.getApi());
  }, []);

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format('YYYY-MM-DD');
    const time1 = moment(time).format('hh:mm a');
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  const handleDateDrop = async info => {
    const { start } = info.oldEvent._instance.range;
    const obj = info.oldEvent._def?.extendedProps?.original;
    const { start: newStart, end: newEnd } = info.event._instance.range;

    // console.log('Old event range: ', start, end);
    // console.log('New event range: ', newStart, newEnd);

    if (new Date(start).getDate() === new Date(newStart).getDate()) {
      info.revert();
    } else {
      await updateJobTable(authToken, obj?.id, {
        startDate: moment(newStart).format('YYYY-MM-DD'),
        endDate: moment(newEnd).format('YYYY-MM-DD'),
        startTime: GetDateMergedTime(newStart, obj?.startTime).toString(),
        endTime: GetDateMergedTime(newEnd, obj?.endTime).toString()
      })
        .then(() => {
          // console.log(res);
          getAllData(
            authToken,
            1,
            ['CNA', 'LPN', 'HHA', 'RN'],
            true,
            [valueCustomer]?.map(i => i?.name)
          );
          toast.success('Date changed successfully.', {
            theme: 'colored'
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  };

  function convertToCSV(jsonData) {
    const separator = ',';
    const keys = Object.keys(jsonData[0]);
    const csvContent = [
      keys.join(separator),
      ...jsonData.map(item => {
        // Extract the 'FullAddress' and 'LicenseType' properties
        const { FullAddress, LicenseType, ...rest } = item;

        // Join the values of the other properties with the 'FullAddress' and 'LicenseType' values
        const values = keys.map(key =>
          key === 'FullAddress'
            ? `"${FullAddress}"`
            : key === 'LicenseType'
            ? `"${LicenseType.join(', ')}"`
            : rest[key]
        );

        return values.join(separator);
      })
    ].join('\n');

    return csvContent;
  }

  const downloadCSVFile = data => {
    let current = moment().format('MM-DD-YYYY');
    // Create a Blob object for the CSV data
    const blob = new Blob([data], { type: 'text/csv' });

    // Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `JobList-${location}-${current}.csv`;

    // Trigger the download
    link.click();

    // Clean up the temporary URL
    URL.revokeObjectURL(url);
  };

  const TabTitle = ({ title }) => (
    <div className="p-2 pe-4 text-start cursor-pointer">
      <h6 className="text-800 fs-8 text-nowrap">{title}</h6>
    </div>
  );

  TabTitle.propTypes = {
    title: PropTypes.string.isRequired
  };

  return (
    <>
      <Tab.Container id="audience-tab" defaultActiveKey="Schedule">
        <SimpleBarReact>
          <Card.Header className="p-0 bg-body-tertiary">
            <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="Schedule">
                  <TabTitle title="Schedule" />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="RosterPlan">
                  <TabTitle title="Roster Plan" />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
        </SimpleBarReact>

        <Card style={{ overflow: 'scroll' }}>
          <Card.Body>
            <Tab.Content>
              <Tab.Pane unmountOnExit eventKey="Schedule">
                <Card>
                  <Card.Header>
                    <Row className="align-items-center gx-0">
                      <Form.Group
                        as={Col}
                        md={3}
                        className="mb-2"
                        controlId="Customer"
                        style={{ zIndex: 10 }}
                      >
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Select customer..."
                          isClearable
                          isSearchable
                          name="color"
                          value={valueCustomer}
                          onChange={value => {
                            setValueCustomer(value);
                          }}
                          options={customers}
                          components={animatedComponents}
                        />
                      </Form.Group>

                      <Col xs="auto" className="d-flex order-md-0">
                        <IconButton
                          variant="primary"
                          iconClassName="me-2"
                          icon="plus"
                          size="sm"
                          className="mb-2 mx-2"
                          onClick={() => {
                            setIsOpenScheduleModal(!isOpenScheduleModal);
                          }}
                        >
                          Create
                        </IconButton>
                      </Col>
                      <Col xs="auto" className="d-flex order-md-0">
                        <Link to={paths.nursd_bid_report} className="me-2">
                          <IconButton
                            variant="info"
                            iconClassName="me-2"
                            icon="chart-pie"
                            className="mb-2 mx-2"
                            size="sm"
                          >
                            <span className="text-light ms-1">Bid Report</span>
                          </IconButton>
                        </Link>
                      </Col>
                      <Col xs="auto" className="d-flex order-md-0">
                        <Link to={paths.nursd_schedule_upload}>
                          <IconButton
                            variant="success"
                            iconClassName="me-2"
                            icon="plus"
                            className="mb-2 mx-2"
                            size="sm"
                          >
                            <span className="text-light ms-1">Upload CSV</span>
                          </IconButton>
                        </Link>
                      </Col>
                      <Col xs="auto" className="d-flex order-md-0">
                        {loading && (
                          <Button
                            variant="primary"
                            className="d-inline-flex flex-center gap-1 mx-2 mb-2"
                            disabled
                          >
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                            Loading...
                          </Button>
                        )}
                      </Col>
                      <Col xs="auto" className="d-flex order-md-0">
                        {downloadData.length !== 0 && (
                          <IconButton
                            variant="falcon-primary"
                            size="sm"
                            iconClassName="me-2"
                            icon="share"
                            transform="shrink-3"
                            className="mb-2 mx-2"
                            onClick={() => setShowShare(!showShare)}
                          >
                            <span className="d-none d-sm-inline-block ms-1">
                              Expand
                            </span>
                          </IconButton>
                        )}
                      </Col>
                      <Col xs="auto" className="d-flex order-md-0">
                        {downloadData.length !== 0 && (
                          <IconButton
                            variant="falcon-default"
                            size="sm"
                            icon="external-link-alt"
                            className="mb-2 mx-2"
                            transform="shrink-3"
                            onClick={() =>
                              downloadCSVFile(convertToCSV(downloadData))
                            }
                          >
                            <span className="d-none d-sm-inline-block ms-1">
                              Export
                            </span>
                          </IconButton>
                        )}
                      </Col>
                      <Col xs="auto" className="d-flex order-md-0">
                        <Link to={paths.nursd_schedule_table('Both', 'All')}>
                          <IconButton
                            variant="falcon-default"
                            iconClassName=""
                            icon=""
                            className="mb-2 mx-2"
                            size="sm"
                          >
                            <span className="d-none d-sm-inline-block ms-1">
                              Job List
                            </span>
                          </IconButton>
                        </Link>
                      </Col>
                    </Row>
                    <Row className="align-items-center mt-3 gx-0">
                      <Col
                        xs="auto"
                        className="d-flex justify-content-end order-md-1"
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip
                              style={{ position: 'fixed' }}
                              id="nextTooltip"
                            >
                              Previous
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="link"
                            className="icon-item icon-item-sm icon-item-hover shadow-none p-0 me-1 ms-md-2"
                            onClick={() => {
                              calendarApi?.prev();
                              setTitle(calendarApi?.getCurrentData().viewTitle);
                            }}
                          >
                            <FontAwesomeIcon icon="arrow-left" />
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip
                              style={{ position: 'fixed' }}
                              id="previousTooltip"
                            >
                              Next
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="link"
                            className="icon-item icon-item-sm icon-item-hover shadow-none p-0 me-lg-2"
                            onClick={() => {
                              calendarApi?.next();
                              setTitle(calendarApi?.getCurrentData().viewTitle);
                            }}
                          >
                            <FontAwesomeIcon icon="arrow-right" />
                          </Button>
                        </OverlayTrigger>
                      </Col>
                      <Col
                        xs="auto"
                        className="d-flex justify-content-end order-md-2"
                      >
                        <h4 className="mb-0 fs-9 fs-sm-8 fs-lg-7">
                          {title ||
                            `${calendarApi?.currentDataManager?.data?.viewTitle}`}
                        </h4>
                      </Col>
                      <Col
                        xs
                        md="auto"
                        className="d-flex justify-content-end order-md-3"
                      >
                        <Button
                          size="sm"
                          variant="falcon-primary"
                          onClick={() => {
                            // calendarApi?.today();
                            // setTitle(calendarApi?.getCurrentData().viewTitle);
                            handleFilter('Day View');
                          }}
                        >
                          Today
                        </Button>
                      </Col>
                      <Col md="auto" className="d-md-none">
                        <hr />
                      </Col>
                      <Col className="d-flex justify-content-end order-md-2">
                        <DropdownFilter
                          className="me-2"
                          filters={viewName}
                          currentFilter={currentFilter}
                          handleFilter={handleFilter}
                          icon="sort"
                          right
                        />
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body className="p-0">
                    <FullCalendar
                      timeZone="local"
                      ref={calendarRef}
                      headerToolbar={false}
                      plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin,
                        listPlugin
                      ]}
                      initialView="dayGridMonth"
                      themeSystem="bootstrap"
                      dayMaxEvents={2}
                      direction={isRTL ? 'rtl' : 'ltr'}
                      height={800}
                      stickyHeaderDates={false}
                      editable
                      selectable
                      selectMirror
                      select={info => {
                        if (
                          moment(info.start).format('MM/DD/YYYYY') >=
                          moment().format('MM/DD/YYYYY')
                        ) {
                          setIsOpenScheduleModal(true);
                          setScheduleStartDate(info.start);
                          setScheduleEndDate(info.end);
                        } else {
                          toast.warn(`You can't create schedule on past day.`, {
                            theme: 'colored'
                          });
                        }
                      }}
                      eventTimeFormat={eventTimeFormat}
                      eventClick={handleEventClick}
                      events={initialEvents}
                      // eventDragStart={info => {
                      //   const obj = info?.event?._instance?.range;
                      //   console.log('Event drag start:', obj);
                      // }}
                      eventDrop={info => {
                        if (
                          moment(info.event.start).isBefore(moment(), 'day')
                        ) {
                          info.revert();
                          toast.error('You cannot move events to past dates.', {
                            theme: 'colored'
                          });
                        } else {
                          handleDateDrop(info);
                        }
                      }}
                    />
                  </Card.Body>
                </Card>
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="RosterPlan">
                {/* <iframe
                  title="My Website"
                  src={`https://roster-plan.vercel.app/roster/${facilityId}/${authToken}`}
                  style={{ width: '100%', height: '100vh', border: 'none' }}
                /> */}
                <Roster />
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Card>
      </Tab.Container>

      <AddScheduleModal
        isOpenScheduleModal={isOpenScheduleModal}
        setIsOpenScheduleModal={setIsOpenScheduleModal}
        initialEvents={initialEvents}
        setInitialEvents={setInitialEvents}
        scheduleStartDate={scheduleStartDate}
        scheduleEndDate={scheduleEndDate}
        setScheduleStartDate={setScheduleStartDate}
        setScheduleEndDate={setScheduleEndDate}
        managers={managers}
        customers={customers}
        nurseList={nurseList}
        authToken={authToken}
        location={location}
        organization={organization}
      />

      <CalendarEventModal
        isOpenEventModal={isOpenEventModal}
        setIsOpenEventModal={setIsOpenEventModal}
        modalEventContent={modalEventContent}
      />

      {!loading && (
        <ShareEventModal
          showShare={showShare}
          setShowShare={setShowShare}
          data={initialEvents?.filter(i => i?.status === 'Open')}
          agency={agency}
          facility={[]}
        />
      )}
    </>
  );
};

export default Calendar;
